export default (params) => ({
  trigger: {
    name: 'product_sub_title.select_subcategory',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'sub_category',
      },
    },
  },
});
